import FirestoreService from "../firestore";
import { Material } from "@/types/material/material.types";

interface FirestoreResponse {
    entity?: string;
    [key: string]: any;
}

export const materialService = {
    create: async (body: Omit<Material, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "create-material",
            body,
            "setup_materials",
            issuedBy
        )) as FirestoreResponse;

        const documentId = result?.entity;
        if (!documentId) {
            throw new Error("Failed to create material: No ID returned");
        }
        return documentId;
    },

    edit: async (id: string, body: Partial<Material>, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "edit-material",
            { id, ...body },
            "setup_materials",
            issuedBy
        )) as FirestoreResponse;
        return result;
    },

    delete: async (documentId: string, issuedBy?: string) => {
        return FirestoreService.request(
            "delete-material",
            { id: documentId },
            "setup_materials",
            issuedBy
        ) as Promise<FirestoreResponse>;
    }
}; 